import React, { useEffect, useRef, useState } from 'react';
import { Modal, Form, Button, Select, Tabs } from 'antd';
import IntlMessages from '../../components/IntlMessage';
import { useIntl } from 'react-intl';
import operatorsApi from '../../api/operators';
import storesApi from '../../api/stores';

const { TabPane } = Tabs;
const { Option } = Select;

const layout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 16 },
};

export default function UpdateAsignFleetForm(props) {
  const isMount = useRef(false);
  const { onClose, idOperator, open } = props;
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [storesEmpty, setStoresEmpty] = useState([]);
  //console.log("?",loading)
  const intl = useIntl();
  const [filter, setFilter] = useState({
    page: 1,
    limit: 1000,
    keyword: '',
    order_by: 'id',
    order_dir: 'DESC',
  });
  useEffect(() => {
    async function fetchData() {
      if (isMount) {
        let result = await operatorsApi.getAllFleetGolden(filter);
        console.log('result', result);
        setStoresEmpty(result.data);
      }
    }
    fetchData();
    return () => {
      isMount.current = false;
    };
  }, []);

  const handleSubmit = () => {
    setLoading(true);

    form
      .validateFields()
      .then((values) => {
        let data = { ...values };
        let asign_data = {
          parent_operator_id: data.operator_id,
        };
        operatorsApi
          .asignFleetGolden(idOperator, asign_data)
          .then(() => {
            setLoading(false);
            handleCancel();
            props.onReload();
          })
          .catch((error) => {
            console.error(error);
            Modal.error({
              title: error.data.message,
              okText: intl.formatMessage({ id: 'global.close' }),
            });
            setLoading(false);
          });
      })
      .catch(() => setLoading(false));
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const handleCancel = () => {
    //form.resetFields();
    onClose();
  };

  return (
    <Modal
      title={<IntlMessages id="global.update" />}
      visible={open}
      destroyOnClose={true}
      onCancel={handleCancel}
      width="60%"
      onOk={handleSubmit}
      footer={[
        <Button key="back" type="default" onClick={handleCancel}>
          {<IntlMessages id="global.cancel" />}
        </Button>,
        <Button
          key="submit"
          type="primary"
          htmlType="submit"
          loading={loading}
          onClick={handleSubmit}
        >
          {<IntlMessages id="global.save" />}
        </Button>,
      ]}
    >
      <Form
        {...layout}
        form={form}
        labelAlign="left"
        onFinish={handleSubmit}
        onFinishFailed={onFinishFailed}
      >
        <Tabs defaultActiveKey="1">
          <TabPane tab={<IntlMessages id="global.fleet_golden" />} key="1">
            <Form.Item
              name="operator_id"
              label={<IntlMessages id="global.fleet_golden" />}
            >
              <Select
                allowClear
                showSearch
                placeholder="Select Fleet Golden"
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {storesEmpty.map((option, index) => {
                  return (
                    <Option key={`${option.id}_${index}`} value={option.id}>
                      {option?.title}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>
          </TabPane>
        </Tabs>
      </Form>
    </Modal>
  );
}
